import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  AfterViewChecked
} from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Directive({ selector: '[app-template-holder]' })

export class TemplateHolderDirective  implements AfterViewChecked {
    // class name to match height
    @Input()
    matchWith: string;

    @Input()
    height: string;

    private _isChecked:boolean = false;

    constructor(private el: ElementRef,private renderer: Renderer2,private logger:NGXLogger) {
    }

    ngAfterViewChecked() {
        // call our matchHeight function here
        this.logger.debug('match height')
        if(!this._isChecked)
          this.matchHeight(this.el.nativeElement.parentElement, this.matchWith);

        //this._isChecked = true;
    }

    matchHeight(parent: HTMLElement, className: string) {
        // match height logic here

        if (!parent) return;

        // step 1: find all the child elements with the selected class name
        const children = parent.getElementsByClassName(className);

        if (!children) return;

        // if height parameter is defined
        if(this.height){
          Array.from(children)
             .forEach((x: HTMLElement) => x.style.height = `${this.height}px`);
        }else{

          const parentHeight = parent.parentElement.getBoundingClientRect().height;
          const parentWidth = parent.parentElement.getBoundingClientRect().width;

          const itemHeights = Array.from(children)
               .map(x => (x as HTMLElement).offsetHeight);

          const itemWidths = Array.from(children)
                    .map(x => (x as HTMLElement).offsetWidth);


          // step 2b: find out the tallest
          const maxHeight = itemHeights.reduce((prev, curr) => {
              return curr > prev ? curr : prev;
          }, 0);

          const maxWidth = itemWidths.reduce((prev, curr) => {
              return curr > prev ? curr : prev;
          }, 0);

          const scale = parentHeight / maxHeight;
          const yDiff = (maxHeight - parentHeight)/2;
          const xDiff = (maxWidth - parentWidth)/2;

          this.el.nativeElement.style.transform = `scale(${scale})`;
          this.el.nativeElement.style.position = "absolute";
          this.el.nativeElement.style.top = `-${yDiff}px`;
          this.el.nativeElement.style.left = `-${xDiff}px`;

        }
        // step 3: update all the child elements to the tallest height
        // Array.from(children)
        //     .forEach((x: HTMLElement) => x.style.height = `${maxHeight}px`);
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/template-holder.directive.ts